import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useIncidentCommand as useLocalIncidentCommand } from '@ngsos/portal-core/commands';
import type { IncidentCommandAction } from '@ngsos/portal-core/commands';

import { readInitialIncidentAction, readInitialIncidentPanel } from '../incident-detail/layout/incidentPanel';

export function useIncidentCommand(
  incidentId: string,
  action: IncidentCommandAction,
  confirmedState: string | null,
  canStart: boolean,
) {
  const command = useLocalIncidentCommand(incidentId, action, confirmedState);
  const location = useLocation();
  const navigate = useNavigate();
  const initialAction = readInitialIncidentAction(location.state);

  useEffect(() => {
    if (initialAction !== action || (!canStart && confirmedState === null)) return;
    void navigate(location.pathname + location.search + location.hash, {
      replace: true,
      state: { initialActivePanel: readInitialIncidentPanel(location.state) },
    });
    if (canStart) void command.start();
  }, [canStart, confirmedState, initialAction, action, command.start, location, navigate]);

  return command;
}
